import { DialogProps } from '@orionprotocol/ui';

export type ConnectWalletDialogProps = {
  // empty
} & DialogProps;

export type UnsupportedNetworkDialogProps = {
  // empty
} & DialogProps;

export type LinkTelegramDialogProps = {
  // empty
} & DialogProps;

export const DialogTypeArray = [
  'ConnectWallet',
  'UnsupportedNetwork',
  'LinkTelegram',
] as const;
export type DialogType = typeof DialogTypeArray[number];

export interface DialogPropTypes {
  ConnectWallet: ConnectWalletDialogProps;
  UnsupportedNetwork: UnsupportedNetworkDialogProps;
  LinkTelegram: LinkTelegramDialogProps;
}

export type WithOptionalProps<T extends DialogType> =
  T extends keyof DialogPropTypes
    ? Omit<DialogPropTypes[T], 'onOpenChange' | 'open'>
    : undefined;
